<label class="custom-toggle">
  <input type="checkbox"
         role="switch"
         [id]="id"
         [formControl]="control">
  <span class="custom-toggle-slider"></span>
</label>
